<div class="flex items-center justify-between space-x-3 pt-6 px-4 pb-5 text-sm">
    <div class="flex items-start space-x-3 text-xs mb-2">
        <button
        *ngFor="let tab of tabs"
        (click)="navigateTo(tab.route)"
        [ngClass]="{
            'btn-dark-orange': isActiveRoute(tab.route),
            'btn-light-orange': !isActiveRoute(tab.route)
        }"
        class="btn-light-orange custom-tabbtn focus:outline-none 
                py-3 px-5 h-15  
                uppercase font-semibold 
                flex items-center justify-center"
        >
        {{ tab.label }}
        </button>
    </div>

    <ng-content></ng-content>
</div>